import { getQueryString, handleError } from "../apiUtils";
import axios from "../axios";

export async function getSpeciesCategories() {
  try {
    const resp = await axios.get("/api/speciesCategory/?pageSize=30");
    return resp.data;
  } catch (error) {
    console.log(error);
    handleError(error);
  }
}
